"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueNumberBuilder = void 0;
const uuid_1 = require("uuid");
const QueueNumber_1 = require("./QueueNumber");
class QueueNumberBuilder {
    constructor() {
        this.qn = {};
    }
    withId(id) {
        this.qn.id = id;
        return this;
    }
    generateId() {
        this.qn.id = (0, uuid_1.v4)();
        return this;
    }
    withNumber(number) {
        this.qn.number = number;
        return this;
    }
    withCallableAfter(callableAfter) {
        this.qn.callableAfter = callableAfter;
        return this;
    }
    withCallableUntil(callableUntil) {
        this.qn.callableUntil = callableUntil;
        return this;
    }
    withTags(tags) {
        this.qn.tags = [...tags];
        return this;
    }
    withLogs(logs) {
        this.qn.logs = [...logs];
        return this;
    }
    withCustomer(customer) {
        this.qn.customer = customer;
        return this;
    }
    withCustomerName(name) {
        if (this.qn.customer === undefined) {
            this.qn.customer = {};
        }
        this.qn.customer.name = name;
        return this;
    }
    withCustomerCode(code) {
        if (this.qn.customer === undefined) {
            this.qn.customer = {};
        }
        this.qn.customer.code = code;
        return this;
    }
    withCustomerPhoneNumber(phoneNumber) {
        if (this.qn.customer === undefined) {
            this.qn.customer = {};
        }
        this.qn.customer.phoneNumber = phoneNumber;
        return this;
    }
    withReservation(reservation) {
        this.qn.reservation = reservation;
        return this;
    }
    withReservationStart(start) {
        if (this.qn.reservation === undefined) {
            this.qn.reservation = {};
        }
        this.qn.reservation.start = start;
        return this;
    }
    withReservationEnd(end) {
        if (this.qn.reservation === undefined) {
            this.qn.reservation = {};
        }
        this.qn.reservation.end = end;
        return this;
    }
    withReservationSummary(summary) {
        if (this.qn.reservation === undefined) {
            this.qn.reservation = {};
        }
        this.qn.reservation.summary = summary;
        return this;
    }
    withReservationTags(tags) {
        if (this.qn.reservation === undefined) {
            this.qn.reservation = {};
        }
        this.qn.reservation.tags = tags;
        return this;
    }
    withDefaults() {
        if (!("tags" in this.qn)) {
            this.qn.tags = [];
        }
        if (!("logs" in this.qn)) {
            this.qn.logs = [];
        }
        if (!this.logsContainsCreatedLogEntry()) {
            this.qn.logs.push(this.createCreatedLogEntry());
        }
        if (!("callableAfter" in this.qn)) {
            this.qn.callableAfter = this.getCallableAfterDefaultValue();
        }
        if (!("callableUntil" in this.qn)) {
            this.qn.callableUntil = this.getCallableUntilDefaultValue();
        }
        return this;
    }
    build() {
        this.withDefaults();
        if (!(0, QueueNumber_1.isQueueNumber)(this.qn)) {
            throw new Error("invalid queue number data");
        }
        if (this.qn.tags !== undefined) {
            if (this.checkForDuplicates(this.qn.tags)) {
                throw new Error("build: duplicate tags");
            }
        }
        return this.qn;
    }
    checkForDuplicates(array) {
        return new Set(array).size !== array.length;
    }
    getCallableAfterDefaultValue() {
        return null;
    }
    getCallableUntilDefaultValue() {
        return null;
    }
    logsContainsCreatedLogEntry() {
        var _a;
        return (_a = this.qn.logs) === null || _a === void 0 ? void 0 : _a.some((log) => log.type === "created");
    }
    createCreatedLogEntry() {
        return {
            type: "created",
            timestamp: new Date(),
        };
    }
}
exports.QueueNumberBuilder = QueueNumberBuilder;
//# sourceMappingURL=QueueNumberBuilder.js.map